//
// HCL Technologies Confidential
// (C) Copyright HCL Technologies 2025. All Rights Reserved.
// The source code for this program is not published or otherwise divested
// of its trade secrets, irrespective of what has been deposited with the
// U.S. Copyright Office.
//

import React, { createContext, useContext } from 'react';
import { OIDCHelper, AuthHelperType } from './oidcConnect';
import { useAuth } from 'react-oidc-context';
import { useConfig } from './Config';

const AuthHelperContext = createContext<AuthHelperType | undefined>(undefined);

export const useAuthHelper = () => {
  const context = useContext(AuthHelperContext);
  if (context === undefined) {
    throw new Error('useAuthHelper must be used within an AuthHelperProvider');
  }
  return context;
};

interface AuthHelperProviderProps {
  children: React.ReactNode;
}

export const AuthHelperProvider: React.FC<AuthHelperProviderProps> = ({
  children,
}) => {
  const auth = useAuth();
  const config = useConfig();

  if (!auth || !config) {
    return null;
  }

  const oidcHelper = OIDCHelper();

  return (
    <AuthHelperContext.Provider value={oidcHelper}>
      {children}
    </AuthHelperContext.Provider>
  );
};
